import { CalendarDays, Users, BarChart3, ShieldCheck, Vault, Zap, BellRing, Gift } from 'lucide-react';
import { SectionLabel, Reveal } from '../Section';

const FEATURES = [
  { icon: CalendarDays, title: 'Daily BGMI & Free Fire Tournaments', desc: 'Fresh tournaments every single day across both games — there is always a match waiting for you.' },
  { icon: Users, title: 'Solo, Duo & Squad Formats', desc: 'Play your way. Lone wolf, with a partner, or with your full squad — every format is covered.' },
  { icon: BarChart3, title: 'Live Leaderboards', desc: 'Track your rank in real time and climb weekly and monthly leaderboards for extra rewards.' },
  { icon: ShieldCheck, title: 'Fair Play System', desc: 'Anti-cheat monitoring, verified IGNs and strict rules keep every match clean and competitive.' },
  { icon: Vault, title: 'Secure Winning Vault', desc: 'Every prize you win lands in your encrypted in-app Winning Vault — safe until you cash out.' },
  { icon: Zap, title: 'Fast Prize Payouts', desc: 'Winnings are credited automatically after results are verified. No chasing, no delays.' },
  { icon: BellRing, title: 'Push Notifications', desc: 'Room IDs, match reminders and result alerts delivered instantly — never miss a match.' },
  { icon: Gift, title: 'Referral & Rewards System', desc: 'Invite friends, earn bonus coins and unlock daily, weekly and milestone rewards.' },
];

export default function Features() {
  return (
    <section className="py-20 sm:py-28 bg-[#0a0a0a]" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionLabel testid="features-label">Why KROY Esports</SectionLabel>
        <Reveal>
          <h2 className="mt-5 font-display text-white text-3xl sm:text-5xl max-w-2xl">
            Built for players who <span className="text-[#e8173a]">play to win</span>
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 4) * 0.08}>
              <div
                data-testid={`feature-card-${i}`}
                className="card-surface card-surface-hover p-6 h-full group"
              >
                <span className="w-11 h-11 rounded-lg bg-[#e8173a]/10 border border-[#e8173a]/25 flex items-center justify-center transition-colors duration-300 group-hover:bg-[#e8173a]/20">
                  <f.icon className="w-5 h-5 text-[#e8173a]" strokeWidth={2.2} />
                </span>
                <h3 className="mt-5 text-white font-bold text-sm leading-snug">{f.title}</h3>
                <p className="mt-2 text-[13px] text-[#9e9e9e] leading-relaxed">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
